import { Action, createReducer, on } from '@ngrx/store';
import { clearTimelineData, createRazorpayOrder, createRazorpayOrderFailure, createRazorpayOrderSuccess, createTransactionsRecord, createTransactionsRecordFailure, createTransactionsRecordSuccess, fetchCounts, fetchCountsFailure, fetchCountsSuccess, fetchNotificationData, fetchNotificationDataFailure, fetchNotificationDataSuccess, fetchTimelineData, fetchTimelineFailure, fetchTimelineSuccess, fetchTransactionsData, fetchTransactionsDataFailure, fetchTransactionsDataSuccess, fetchTransactionsStatsData, fetchTransactionsStatsDataFailure, fetchTransactionsStatsDataSuccess, fetchVendorAllClients, fetchVendorAllClientsSuccess, fileDeleteOnServer, fileDeleteOnServerSuccess, fileUploadOnServer, fileUploadOnServerSuccess, globalsearch, globalsearchSuccess } from './common.actions';
import { TimelineModel } from '../../core/models/timeline.models';
import { TransactionModule } from '../../pages/transactionsmodule/transaction.module';
import { User } from '../../core/models/user.models';
import { QuickIndex } from '../../core/models/quickindex.models';

export interface CommonState {
    error: string | null;
    loading: boolean;
    countsobj: any;
    timelines: TimelineModel[];
    transactions: TransactionModule[];
    orderdata: any;
    success: boolean;
    clients: User[];
    searchRecords: QuickIndex[];
    transactionloading: boolean;
    stats: any;
}

const initialState: CommonState = {
    error: null,
    loading: false,
    countsobj: null,
    timelines: [],
    transactions: [],
    orderdata: null,
    success: false,
    clients: [],
    searchRecords: [],
    transactionloading: false,
    stats: null
};

export const commonReducer = createReducer(
    initialState,
 //counts
 on(fetchCounts, (state) => ({ ...state, error: null, user: null, loading: true })),
 on(fetchCountsSuccess, (state, { countsobj }) => ({ ...state, countsobj })),
 on(fetchCountsFailure, (state, { error }) => ({ ...state, error, user: null, loading: false })),

 // Timelines
 on(fetchTimelineData, (state) => {
    return { ...state, loading: true, error: null };
}),
on(fetchTimelineSuccess, (state, { timelines }) => {
    return { ...state, timelines, loading: false };
}),
on(fetchTimelineFailure, (state, { error }) => {
    return { ...state, error, loading: false };
}),
on(clearTimelineData, () => {
    return { ...initialState };
}),

// Transactions Stats
on(fetchTransactionsStatsData, (state) => {
    return { ...state, transactionloading: true, error: null };
}),
on(fetchTransactionsStatsDataSuccess, (state, { stats }) => {
    return { ...state, stats, transactionloading: false };
}),
on(fetchTransactionsStatsDataFailure, (state, { error }) => {
    return { ...state, error, transactionloading: false };
}),

// Transactions
on(fetchTransactionsData, (state) => {
    return { ...state, transactionloading: true, error: null };
}),
on(fetchTransactionsDataSuccess, (state, { transactions }) => {
    return { ...state, transactions, transactionloading: false };
}),
on(fetchTransactionsDataFailure, (state, { error }) => {
    return { ...state, error, transactionloading: false };
}),

on(createRazorpayOrder, (state) => {
    return { ...state, loading: true, error: null };
}),
on(createRazorpayOrderSuccess, (state, { orderdata }) => {
    return { ...state, orderdata, loading: false };
}),
on(createRazorpayOrderFailure, (state, { error }) => {
    return { ...state, error, loading: false };
}),

// Transactions
on(createTransactionsRecord, (state) => {
    return { ...state, loading: true, error: null };
}),
on(createTransactionsRecordSuccess, (state) => {
    return { ...state, loading: false, error: null, success: true };
}),

// All Clients
on(fetchVendorAllClients, (state) => {
    return { ...state, loading: true, error: null };
}),
on(fetchVendorAllClientsSuccess, (state, { clients }) => {
    return { ...state, loading: false, error: null, clients };
}),

// FILE UPLOAD
on(fileUploadOnServer, (state) => {
    return { ...state, loading: true, error: null };
}),
on(fileUploadOnServerSuccess, (state) => {
    return { ...state, loading: false, error: null};
}),

// GLOBAL SEARCH
on(globalsearch, (state) => {
    return { ...state, loading: true, error: null };
}),
on(globalsearchSuccess, (state, { searchRecords }) => {
    return { ...state, loading: false, error: null, searchRecords};
}),

//Notifications
on(fetchNotificationData, (state) => {
    return { ...state, loading: true, error: null };
}),
on(fetchNotificationDataSuccess, (state, { notifications }) => {
    return { ...state, notifications, loading: false };
}),
on(fetchNotificationDataFailure, (state, { error }) => {
    return { ...state, error, loading: false };
}),

);

// Selector
export function reducer(state: CommonState | undefined, action: Action) {
    return commonReducer(state, action);
}